export default {
    props: {
        data: null,
    },
    data() {
        return {
            anim: true,
            duration: 75000,
        }
    },
    methods: {
        widthFix() {
            let width = 0
            let el = this.$refs.carousel.$el
            const innerEl = el.querySelector('.owl-stage')

            if (!innerEl) {
                return -1;
            }

            innerEl.childNodes.forEach(element => {
                width += element.offsetWidth
            });

            innerEl.style.width = width
        }, 
        animateTicker(el, duration, replay = false) {
            const innerEl = el.querySelector('.owl-stage')
            
            if (!innerEl) {
                return -1;
            }
        
            const innerWidth = innerEl.offsetWidth / 5;
        
            let start = performance.now();
            let progress;
            let translateX;
            let shift = 0;
            let vm = this;
           
            if (replay) {
                const re = /translate3d\((?<x>.*?)px, (?<y>.*?)px, (?<z>.*?)px/
                const results = re.exec(innerEl.style.transform);
                shift = +results.groups.x * (-1)
            }

            requestAnimationFrame(function step() {     
                if (vm.anim)  {
                  
                    let now = performance.now()
                    progress = (now - start) / (duration + innerEl.offsetWidth); 
                    translateX = innerWidth * progress + shift

                    if (translateX > innerWidth * 3) {
                        vm.widthFix()
                        progress = 0
                        start = now
                        shift = 0
                    } 

                    innerEl.style.transform = `translate3d(-${(translateX)}px, 0 , 0)`;  
                    innerEl.style.transition = `none`;  
                    requestAnimationFrame(step)
                }
            });
        }, 
    },
    watch: {
        anim(value) {
            if (value) {
                this.animateTicker(
                    this.$refs.carousel.$el, 
                    this.duration, 
                    true
                );
            }
        },
    },
    computed: {
        items() {
            return (this.data?.length ?? 0) * 2
        }
    },
    async mounted() {
        await this.$nextTick()
         
        setTimeout(() => {      
            this.animateTicker(
                this.$refs.carousel.$el, 
                this.duration
            )
        }, 200);
    }
}